import React, { useEffect } from 'react';
import { formatDate } from '../../Components/InputElements';
import Select from 'react-select';
import { monthDataSelect } from '../../Constants/constants';

const LeaveGeneralSettingsView = ({prevInfo, updatedInfo, handleClose}) => {
    const close=()=>{
        handleClose("LeaveGeneralSettingsView");
    }
    useEffect(()=>{
        console.log("prevInfo",prevInfo);
        console.log("updatedInfo",updatedInfo);
    },[])
    return (
        <div className="modal show" 
        style={{
            display: "block",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
        }}  >
            <div className="modal-dialog modal-xl"
                style={{ width: "90%" }}>
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="rmModalLabel">Leave General Setting Log Info</h5>
                        <button type="button" className="btn-close" onClick={()=> close()} aria-label="Close" />
                    </div>
                    <div className="modal-body">
                        <div className="container mt-2">
                            <div className="row">
                                <div className="col-md-6 px-0  ">
                                    <div style={{ margin: "3px"}} className="  p-2 rounded-3 grayBlurShadow ">
                                        <h5>Previous Log Info</h5>
                                        <div className="row">                
                                            <div className="col-md-6 mt-3">
                                                <label className="form-label">Which month the Leave Cycle Starts</label>
                                                <input
                                                    type="text"
                                                    className={`form-control`}
                                                    id="leave_cycle"
                                                    name="leave_cycle"
                                                    disabled
                                                    value={prevInfo?.leave_cycle_start_month || "--"}
                                                />
                                            </div>                                   
                                            <div className="col-md-6 mt-3">
                                                <label className="form-label">Should Admin has access to leave module to Approve,
                                                Reject or Cancel the Leaves</label>
                                                <input
                                                    type="text"
                                                    className={`form-control`}
                                                    id="actual_employee_name"
                                                    name="actual_employee_name"
                                                    disabled
                                                    value={prevInfo?.admin_access_leave_module=="1" ? "Yes":"No"}
                                                />
                                            </div>                                   
                                            <div className="col-md-6 mt-3">
                                                <label htmlFor="round_off_leave_accrual" className="form-label">Should we round of the leave accrual nearest to 0.5 Unit</label>
                                                <input
                                                    type="text"
                                                    className={`form-control`}
                                                    id="round_off_leave_accrual"
                                                    name="round_off_leave_accrual"
                                                    disabled
                                                    value={prevInfo?.round_off_leave_accrual=="1" ? "Yes" : "No"}
                                                />
                                            </div>                                   
                                            <div className="col-md-6 mt-3">
                                                <label  className="form-label">Would you like to display closing leave balance in Pay Slip</label>
                                                <input
                                                    type="text"
                                                    className={`form-control`}
                                                    id="display_closing_leave_balance"
                                                    name="display_closing_leave_balance"
                                                    disabled
                                                    value={prevInfo?.display_closing_leave_balance=="1" ? "Yes" : "No"}
                                                />
                                            </div>                                   
                                            <div className="col-md-6 mt-3">
                                                <label  className="form-label">How many Levels approval to be set</label>
                                                <input
                                                    type="text"
                                                    className={`form-control`}
                                                    id="leave_approve_level"
                                                    name="leave_approve_level"
                                                    disabled
                                                    value={prevInfo?.leave_approve_level=="1" ? "Level 1" : "Level 1 & Leavel 2"}
                                                />
                                            </div>                                   
                                        </div>
                                    </div>
                                </div>
                                <div className=" col-md-6 px-0 ">
                                    <div style={{ margin: "3px"}} className=" p-2 rounded-3 grayBlurShadow">
                                        <h5>Updated Log Info</h5>
                                        <div className="row">
                                            <div className="col-md-6 mt-3">
                                                <label className="form-label">Which month the Leave Cycle Starts</label>
                                                <input
                                                    type="text"
                                                    className={`form-control`}
                                                    id="leave_cycle"
                                                    name="leave_cycle"
                                                    disabled
                                                    value={updatedInfo?.leave_cycle_start_month || "--"}
                                                />
                                            </div>                
                                            <div className="col-md-6 mt-3">
                                                <label className="form-label">Should Admin has access to leave module to Approve,
                                                Reject or Cancel the Leaves</label>
                                                <input
                                                    type="text"
                                                    className={`form-control`}
                                                    id="actual_employee_name"
                                                    name="actual_employee_name"
                                                    disabled
                                                    value={updatedInfo?.admin_access_leave_module=="1" ? "Yes":"No"}
                                                />
                                            </div>                                   
                                            <div className="col-md-6 mt-3">
                                                <label htmlFor="round_off_leave_accrual" className="form-label">Should we round of the leave accrual nearest to 0.5 Unit</label>
                                                <input
                                                    type="text"
                                                    className={`form-control`}
                                                    id="round_off_leave_accrual"
                                                    name="round_off_leave_accrual"
                                                    disabled
                                                    value={updatedInfo?.round_off_leave_accrual=="1" ? "Yes" : "No"}
                                                />
                                            </div>                                 
                                            <div className="col-md-6 mt-3">
                                                <label  className="form-label">Would you like to display closing leave balance in Pay Slip</label>
                                                <input
                                                    type="text"
                                                    className={`form-control`}
                                                    id="display_closing_leave_balance"
                                                    name="display_closing_leave_balance"
                                                    disabled
                                                    value={updatedInfo?.display_closing_leave_balance=="1" ? "Yes" : "No"}
                                                />
                                            </div>                                                                                                                                        
                                            <div className="col-md-6 mt-3">
                                                <label  className="form-label">How many Levels approval to be set</label>
                                                <input
                                                    type="text"
                                                    className={`form-control`}
                                                    id="leave_approve_level"
                                                    name="leave_approve_level"
                                                    disabled
                                                    value={updatedInfo?.leave_approve_level=="1" ? "Level 1" : "Level 1 & Leavel 2"}
                                                />
                                            </div>  
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LeaveGeneralSettingsView;
